import Marionette from "backbone.marionette";
import { ExperienceSelectorCollectionItemView } from "./ExperienceSelectorCollectionItemView";

export const ExperienceSelectorCollectionView = Marionette.CollectionView.extend({
    className: "ExperienceSelectorCollectionView row",

    childView: ExperienceSelectorCollectionItemView,
    childViewEventPrefix: "experience",

    initialize(options) {
        this.selectedExperiences = options.selectedExperiences;

        this.listenTo(this.collection, "add", this.onAdd);
    },

    onAdd(experience) {
        if (this.selectedExperiences.all) {
            this.selectedExperiences.selected.push(experience.id);
        }
    },

    childViewOptions(model) {
        return {
            selected: this.selectedExperiences.all || this.selectedExperiences.selected.indexOf(model.id) > -1
        }
    }
});


// WEBPACK FOOTER //
// ./src/js/view/components/ExperienceSelector/ExperienceSelectorCollectionView.js